import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMTubeChannelsApi = createApi({
  reducerPath: 'lMTubeChannelsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['TubeChannels'],
  endpoints: builder => ({
    getTubeChannels: builder.query({
      query: (params) => ({
        url: `/links/tube/channels/`,
        params,
      }),
      providesTags: ['TubeChannels']
    }),

    createTubeChannel: builder.mutation({
      query: body => ({
        url: '/links/tube/channels/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['TubeChannels']
    }),

    getTubeChannelById: builder.query({
      query: id => ({
        url: `/links/tube/channels/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'TubeChannels', id }]
    }),

    updateTubeChannelById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/tube/channels/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['TubeChannels']
    }),

    deleteTubeChannelById: builder.mutation({
      query: id => ({
        url: `/links/tube/channels/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [{ type: 'TubeChannels', id }]
    }),
  })
})

export const {
  useGetTubeChannelsQuery,
  useCreateTubeChannelMutation,
  useGetTubeChannelByIdQuery,
  useUpdateTubeChannelByIdMutation,
  useDeleteTubeChannelByIdMutation,
} = lMTubeChannelsApi
